import React from 'react';
import { Text, TextStyle } from 'react-native';

interface IStyleKey {
  keyName: string;
  keyValue: string;
  style?: TextStyle;
}

interface IMultiStyleTextProps {
  templateString: string;
  styleKeys: IStyleKey[];
  normalStyle: TextStyle;
}

const MultiStyleText: React.FC<IMultiStyleTextProps> = ({
  templateString,
  styleKeys,
  normalStyle,
}) => {
  const textParts: { text: string; style: TextStyle }[] = [];
  let remainingTemplate = templateString;

  styleKeys.forEach((styleKey) => {
    const key = `{{${styleKey.keyName}}}`;
    const parts = remainingTemplate.split(key);

    if (parts.length > 1) {
      if (parts[0]) {
        textParts.push({ text: parts[0], style: normalStyle });
      }

      textParts.push({ text: styleKey.keyValue, style: styleKey.style || normalStyle });
      remainingTemplate = parts.slice(1).join(key);
    }
  });

  if (remainingTemplate) {
    textParts.push({ text: remainingTemplate, style: normalStyle });
  }

  return (
    <Text style={normalStyle}>
      {textParts.map((part) => (
        <Text style={part.style}>
          {part.text}
        </Text>
      ))}
    </Text>
  );
};

export default MultiStyleText;
